import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-reminder-students-to-add",
	templateUrl: "./reminder-students-to-add.component.html",
	styleUrls: ["./reminder-students-to-add.component.css"],
})
export class ReminderStudentsToAddComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateFilters();
	}

	ngOnChanges(): void {
		this.UpdateFilters();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() RemoveAll: EventEmitter<any> = new EventEmitter();
	@Output() RemovePerson: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	@Input() loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;
	@Input() lstPerson: any = [];

	//Filter lists
	lstPersonTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ID", header: "ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "PersonTypeDesc", header: "Person Type" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateFilters() {
		this.lstPersonTypeDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.PersonTypeDesc))).sort();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRemoveAll() {
		this.RemoveAll.emit(true);
	}

	onRemove(Person) {
		this.onRowUnselect(null);
		this.RemovePerson.emit(Person);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		this.SelectedPerson = Person;
	}
	////////////////////////////////////////////
}
